import { useInfiniteQuery, UseInfiniteQueryOptions } from '@tanstack/react-query';
import { SnackbarStatus, useSnackbar } from '@weareopenr/component-library';
import { QueryKeys } from 'src/hooks/QueryKeys';
import { parseQueryParamsFromRelativeUrlPath } from 'src/helpers';
import { ItemModifierGroupsResponseBody } from 'src/api/getModifierGroups/types';
import { getModifierGroups } from 'src/api/getModifierGroups/getModifierGroups';
import { useMemo } from 'react';

interface IItemModifierGroupsOptions {
  priceSchemeId: string;
  limit?: number;
  name?: string;
  menus?: string[];
  options?: UseInfiniteQueryOptions<ItemModifierGroupsResponseBody>;
}

export const useItemModifierGroups = ({
  priceSchemeId,
  limit = 50,
  name,
  menus,
  options,
}: IItemModifierGroupsOptions) => {
  const { showSnackbar } = useSnackbar();

  const queryKey = useMemo(
    () => [QueryKeys.itemModifierGroups, limit, priceSchemeId, name, menus],
    [limit, priceSchemeId, name, menus],
  );
  const query = useInfiniteQuery<ItemModifierGroupsResponseBody>({
    queryKey,
    queryFn: async ({ pageParam }) => getModifierGroups(priceSchemeId, limit, name, pageParam, menus),
    getNextPageParam: (lastPage) => {
      const nextPageUrlPath = lastPage?.paging.next;

      if (!nextPageUrlPath) return null;

      return parseQueryParamsFromRelativeUrlPath(nextPageUrlPath).get('after_id');
    },
    refetchOnWindowFocus: false,
    onError: () => showSnackbar({ status: SnackbarStatus.ERROR, message: 'Internal Server Error' }),
    ...options,
  });

  return { ...query, queryKey };
};

export default useItemModifierGroups;
